export default "__VITE_ASSET__2Rm76UIM__"